module.exports = __webpack_public_path__ + "03ee0270d5fe544b125931548f705625.svg";